export default __webpack_public_path__ + "images/loggedout/review-images/review2-5c8721596f44429ed8c48a101cb38db2.svg";